// 配置编译环境和线上环境之间的切换
let baseUrl = '';
let iconfontVersion = ['567566_pwc3oottzol'];
let iconfontUrl = `//at.alicdn.com/t/font_$key.css`;
let codeUrl = `${baseUrl}/code`
const env = process.env
let localbaseUrl ='';
// 192.144.173.172
if (env.NODE_ENV == 'development') {
    // baseUrl = `http://58.222.34.31:8089/basic`; // 开发环境地址
    baseUrl = `http://127.0.0.1:8089`; // 开发环境地址
    localbaseUrl = 'http://127.0.0.1:8089/#/';
} else if (env.NODE_ENV == 'production') {
  baseUrl = `http://127.0.0.1:8082/jeecgboot`; //生产
  localbaseUrl = 'https://zkqk.start-info.com.cn/#/';
}
export {
    baseUrl,
    iconfontUrl,
    iconfontVersion,
    codeUrl,
    env,
   localbaseUrl
}



// WEBPACK FOOTER //
// ./src/config/env.js